if (!customElements.get('featured-page')) {
    customElements.define('featured-page', class FeaturedPage extends HTMLElement {
        constructor() {
            super();
            this.wlSwiper = null;
            console.log('featured-page constructor');
        }

        connectedCallback() {
            this.initializeSwiper();
        }
        
        initializeSwiper() {
            this.wlSwiper = new Swiper(this, {
                enabled: true,
                slidesPerView: 1.4,
                spaceBetween: 23,
                centeredSlides: false,
                a11y: true,
                keyboardControl: true,
                grabCursor: true,
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                runCallbacksOnInit: true,
                breakpoints: {
                    600: {
                        enabled: false,
                    }
                }
            });
        }
    });
  }
  